import styled from 'styled-components';

import { iconSize, styledMedia, styledTypography } from '@pkg/primitives';

import { tokens } from './tokens';

interface StyledCurrencyDisplayProps {
    $compact?: boolean;
}

export const StyledCurrencyDisplay = styled.div<StyledCurrencyDisplayProps>`
    --yat_currency-display-suffix-margin-left: ${({ $compact }) =>
        $compact ? tokens.suffix.marginLeft.compact : tokens.suffix.marginLeft.default}px;
    --yat_currency-display-label-font-size: ${({ $compact }) =>
        $compact ? tokens.label.fontSize.compact : tokens.label.fontSize.default}px;
    --yat_currency-display-conversion-font-size: ${({ $compact }) =>
        $compact ? tokens.conversion.fontSize.compact : tokens.conversion.fontSize.default}px;

    display: flex;
    align-items: center;
`;

export const Symbol = styled.div`
    ${styledMedia.iconWrapper};
    width: ${iconSize.default}px;
    height: ${iconSize.default}px;
`;

export const Suffix = styled.div`
    margin-left: var(--yat_currency-display-suffix-margin-left);
`;

export const Label = styled.p`
    ${styledTypography.allianceBase};
    font-size: var(--yat_currency-display-label-font-size);
    font-weight: 700;
`;

export const Conversion = styled.p`
    ${styledTypography.allianceBase};
    font-size: var(--yat_currency-display-conversion-font-size);
    font-weight: 700;
    // font-variant-numeric: tabular-nums;
    color: rgba(255, 255, 255, 0.6);

    &:nth-child(2) {
        margin-top: 0.2em;
    }
`;
